import Insight from './insightResource';
import transformFilters from './transformer/filterTransformer';
import normalizeFilterParams from './normalizer/filtersNormalizer';
import normalizeChartParams from './normalizer/chartsNormalizer';
import normalizeTableParams from './normalizer/tablesNormalizer';
import normalizeCsvParams from './normalizer/CSVNormalizer';
import transformTables from './transformer/tableTransformer';
import transformDashboard from './transformer/dashboardTransformer';
import transformCSV from '../shared/transformers/CSVTransformer';
import transformEvent from './transformer/eventTransformer';
import transformChart from './transformer/chartTransformer';

function getFilters({ app, packageName, defaults }) {
  const params = normalizeFilterParams(app, packageName);
  return Insight.getFilters(params).then(
    ({
      body: {
        config: { types, ranges },
      },
    }) => transformFilters({ types, ranges, defaults }),
  );
}

function getCharts({ app, packageName, selectedFilters }) {
  const params = normalizeChartParams({
    app,
    packageName,
    selectedFilters,
  });
  return Insight.getStats(params).then(({ body: { charts } }) =>
    transformChart(charts),
  );
}

function getTables({ packageName, app, selectedFilters }) {
  const params = normalizeTableParams({
    packageName,
    app,
    selectedFilters,
  });
  return Insight.getStats(params).then(({ body: { columns, data } }) =>
    transformTables({ columns, data }),
  );
}

function getCsv({ haveIAP, selectedType, range, packageName }) {
  const params = normalizeCsvParams({
    haveIAP,
    selectedType,
    range,
    packageName,
  });
  return Insight.getCsv(params).then(res => transformCSV(res));
}

function getDashboard(packageName) {
  return Insight.getDashboard({ packageName }).then(({ body: { charts } }) =>
    transformDashboard(charts),
  );
}

function getEvents({ packageName, range }) {
  return Insight.getEvents({
    packageName,
    range,
  }).then(({ body: { events = [] } }) => events.map(transformEvent));
}

export default {
  getDashboard,
  getFilters,
  getCharts,
  getTables,
  getCsv,
  getEvents,
};
